import React from 'react';
import CountUp from 'react-countup';
import hero from '../../Assets/home.jpg';
import { FaChalkboardTeacher, FaBookOpen, FaUserGraduate, FaAward } from 'react-icons/fa';

const Home = () => {
  return (
    <div className="flex flex-col w-full">
      {/* Hero Section */}
      <div className="flex w-full">
        <div className="w-1/2 p-4">
          <h1 className="text-5xl font-semibold mb-4 leading-tight">
            Learn Topics That <br />  
            Matter To You
          </h1>
          <p className="text-gray-400 font-medium text-md mb-6">
            Unlock your potential by learning from an elite community of instructors, 
            experts, and thought leaders. Discover high-quality courses tailored to your needs and interests.
          </p>
          <ul className="text-gray-500 font-medium list-disc marker:first-letter: pl-6  mb-6">
            <li>Expert-led courses designed for practical learning.</li>
            <li>Access to a global community of learners.</li>
            <li>Flexible schedules to suit your lifestyle.</li>
          </ul>
          <button className="bg-[#1ba6db] text-white font-semibold px-6 py-3 rounded-full hover:bg-[#1594c8] transition-all">
            Explore Courses
          </button> 
        </div>
        <div className="w-1/2">
          <div className="relative">
            <img src={hero} alt="hero" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    <section className="grid gap-8  md:grid-cols-4 mt-16 px-8">
      {/* Block #1: Teachers */}
      <article className="flex flex-col items-center  p-6 rounded-2xl ">
        <div className="bg-indigo-100 p-4 rounded-full shadow-md mb-4">
          <FaChalkboardTeacher className="text-indigo-600 text-3xl" />
        </div> 
        <h2 className="text-indigo-600 text-4xl font-semibold mb-2">
          <CountUp end={42} duration={2} />+
        </h2>
        <p className="text-indigo-600 font-semibold text-lg">Teachers</p>
        <p className="text-sm text-gray-500 mt-2 text-center">
        Expert educators dedicated to your growth.
        </p>
      </article>
      {/* Block #2: Courses */}
      <article className="flex flex-col items-center   p-6 rounded-2xl ">
        <div className="bg-green-100 p-4 rounded-full shadow-md mb-4">
          <FaBookOpen className="text-green-600 text-3xl" />
        </div>
        <h2 className="text-green-600 text-4xl font-semibold mb-2">
          <CountUp end={35} duration={2} />+
        </h2>
        <p className="text-green-600 font-semibold text-lg">Courses</p>
        <p className="text-sm text-gray-500 mt-2 text-center">
          Tailored programs to match your goals.
        </p>
        {/* ``elines of code: */}
      </article>

      {/* Block #3: Students */}  
      <article className="flex flex-col items-center  p-6 rounded-2xl  ">
        <div className="bg-yellow-100 p-4 rounded-full shadow-md mb-4">
          <FaUserGraduate className="text-yellow-600 text-3xl" />
        </div>

        <h2 className="text-yellow-600  text-4xl font-semibold mb-2">
          <CountUp end={1600} duration={3} />+
        </h2>
        
        <p className="text-yellow-600 font-semibold text-lg">Students</p>
        <p className="text-sm text-gray-500 mt-2 text-center">
          Join a thriving community of learners.
        </p>  
      </article>
      <article className="flex flex-col items-center    p-6 rounded-2xl  ">
        <div className="bg-red-100 p-4 rounded-full shadow-md mb-4">
          <FaAward className="text-red-600 text-3xl" />
        </div>
        <h2 className="text-red-600  text-4xl font-semibold mb-2">
          <CountUp end={800} duration={3} />+
        </h2>
        
        <p className="text-red-600 font-semibold text-lg">Rank Holders</p>

        <p className="text-sm text-gray-500 mt-2 text-center">
          Celebrating academic excellence and success.
        </p>
      </article>

    </section>

    </div>
  );
};

export default Home;
